import { N500 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';

const text =
  "Charlie Text, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const SocialButtonIcon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 8px;
  margin-bottom: 0;
`;

export const DefaultButton = styled.div`
  height: 39px;
  width: 100%;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  cursor: pointer;
  font-weight: 500;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;

  margin: 0px 0px 20px 0px;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${text};
  font-style: normal;
  background-color: #e8e9ee;
`;

export const SocialButton = styled.a`
  text-decoration: none;
  height: 39px;
  width: 100%;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  :hover{
    color: ${N500}
    text-decoration: none;
  }
  cursor: pointer;
  font-weight: 500;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;
  background-color: #FFF;

  margin: 0px 0px 20px 0px;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${text};
  font-style: normal;
`;

export const SocialButtonDefaultExpandedEmail = styled.a`
  text-decoration: none;
  height: 40px;
  width: 100%;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  :hover{
    color: ${N500}
    text-decoration: none;
  }
  cursor: pointer;
  font-weight: 500;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;
  background-color: #FFF;

  margin: 40px 0px 24px 0px;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${text};
  font-style: normal;
`;
